import React, { useEffect, useState } from "react";
import "./Input.scss";

import Text from "../Text/Text";
const Input = ({ label, type = "text", placeholder, value, onChange, icon, name, error,errorMessage="error",disabled=false,className }) => {
    const isCurrency = type === "currency";
    const [typeState,setTypeState] = useState(isCurrency ? "text" : type);

    useEffect(() => {
        setTypeState(isCurrency ? "text" : type);
    }, [isCurrency, type]);

    const formatCurrencyFromDigits = (digitsValue) => {
        const safeDigits = String(digitsValue ?? "")
            .replace(/\D/g, "")
            .slice(0, 15);
        const cents = safeDigits ? parseInt(safeDigits, 10) : 0;

        return `$ ${(cents / 100).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

    const extractDigitsFromCurrencyValue = (rawValue) => {
        if (rawValue === null || rawValue === undefined) return "";
        if (typeof rawValue === "number") {
            const cents = Math.max(0, Math.round(rawValue * 100));
            return String(cents);
        }
        return String(rawValue).replace(/\D/g, "");
    };

    const emitCurrencyChange = (e, digitsValue) => {
        const formattedValue = formatCurrencyFromDigits(digitsValue);

        onChange?.({
            ...e,
            target: {
                ...e.target,
                name,
                value: formattedValue,
            },
            currentTarget: {
                ...e.currentTarget,
                name,
                value: formattedValue,
            },
        });
    };

    const getCurrencyDisplayValue = (rawValue) => {
        const digitsValue = extractDigitsFromCurrencyValue(rawValue);
        return formatCurrencyFromDigits(digitsValue);
    };

    const handleChange = (e) => {
        if (!isCurrency) {
            onChange?.(e);
            return;
        }

        const digitsValue = String(e.target.value).replace(/\D/g, "");
        emitCurrencyChange(e, digitsValue);
    };

    const handleCurrencyKeyDown = (e) => {
        if (!isCurrency) return;
        if (e.ctrlKey || e.metaKey || e.altKey) return;

        const navigationKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"];
        if (navigationKeys.includes(e.key)) return;

        if (!/^\d$/.test(e.key)) {
            e.preventDefault();
        }
    };

    const handleCurrencyPaste = (e) => {
        if (!isCurrency) return;
        e.preventDefault();

        const pastedText = e.clipboardData?.getData("text") ?? "";
        const digitsValue = pastedText.replace(/\D/g, "");
        emitCurrencyChange(e, digitsValue);
    };

    const inputValue = isCurrency ? getCurrencyDisplayValue(value) : (value ?? "");
    
    return (
        <div className={`input-field ${error ? "has-error" : ""} animate__animated animate__fadeInUp ${className}`} >
            {label && <Text size="small" color={'var(--gray-dark-500)'} className="input-label">{label}</Text>}
            <div className="input-wrapper">
                {icon && <span data-icon={icon} className="icon input-icon" />}
                <input
                    className={`input-element ${icon ? "has-left-icon" : ""} ${type === "password" ? "has-right-icon" : ""} ${disabled ? "disabled" : ""}`}
                    type={typeState}
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={handleChange}
                    onKeyDown={handleCurrencyKeyDown}
                    onPaste={handleCurrencyPaste}
                    inputMode={isCurrency ? "numeric" : undefined}
                    autoComplete="off"
                    name={name}
                    disabled={disabled}
                />
                {type === "password" && <div className="preview icon" data-icon="visibility" onClick={()=>{typeState === "password" ? setTypeState("text") : setTypeState("password")}}></div>}
            </div>
            {error && <Text className="input-error" color={'var(--red-600)'} size="small">{errorMessage}</Text>}
        </div>
    );
}
export default Input;